import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import Name from "./Name";
import getBusinessName from "../common/Business";
import Address from "./Address";
import { getDate } from "../common/DisplayDate";

class BljBankruptcies extends Component {
  componentDidMount() {}

  render() {
    const { bljRecord } = this.props;
    const addresses = [];
    const locations = [];
    _.forEach(_.get(bljRecord, "debtors[0].debtor"), (detail, addIndex) => {
      const addressNode = _.get(detail, "address[0]");
      addresses.push(
        <Table.Row key={`row_debtor_address_${addIndex}`}>
          <Table.Cell className={"table-no-border"}>
            <Address addressNode={addressNode} />
          </Table.Cell>
        </Table.Row>
      );
    });
    _.forEach(_.get(bljRecord, "court"), (detail, locIndex) => {
      const addressNode = _.get(detail, "address[0]");
      locations.push(
        <Table.Row key={`row_court_address_${locIndex}`}>
          <Table.Cell className={"table-no-border"}>
            <Address addressNode={addressNode} />
          </Table.Cell>
        </Table.Row>
      );
    });
    const businessName = _.get(
      bljRecord,
      "debtors[0].debtor[0].businessName[0]._",
      ""
    );

    return (
      <Table
        key={`InstantCriminal_Table_${this.props.index}`}
        className={`sub-table`}
      >
        <Table.Body>
          <Table.Row
            className={`${
              this.props.index % 2 === 1 ? "table-row-odd-child" : ""
            }`}
          >
            <Table.Cell className={"sub-table-cell text-bold"} width={2}>
              Debtor Name:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"} width={4}>
              {businessName !== "" ? (
                getBusinessName(businessName, this.props)
              ) : (
                <Name
                  node={_.get(bljRecord, "debtors[0].debtor[0].name[0]")}
                  handleNewSearchClick={this.props.handleNewSearchClick}
                />
              )}
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"} width={2}>
              Chapter:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"} width={2}>
              {_.get(bljRecord, "chapter[0]._")}
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"} width={2}>
              Court:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"} width={4}>
              {_.get(bljRecord, "courtDistrict[0]._", "")}
            </Table.Cell>
          </Table.Row>
          <Table.Row
            className={`${
              this.props.index % 2 === 1 ? "table-row-odd-child" : ""
            }`}
          >
            <Table.Cell className={"sub-table-cell text-bold"} width={2}>
              Debtor Address:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"} width={4}>
              <Table className={"background-color-transparent table-no-border"}>
                <Table.Body>{addresses}</Table.Body>
              </Table>
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"} width={2}>
              Case Number:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"} width={2}>
              {_.get(bljRecord, "caseNumber[0]._", "")}
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"} width={2}>
              Court Location:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"} width={4}>
              <Table className={"background-color-transparent table-no-border"}>
                <Table.Body>{locations}</Table.Body>
              </Table>
            </Table.Cell>
          </Table.Row>
          <Table.Row
            className={`${
              this.props.index % 2 === 1 ? "table-row-odd-child" : ""
            }`}
          >
            <Table.Cell className={"sub-table-cell text-bold"} width={2} />
            <Table.Cell className={"sub-table-cell"} width={4} />
            <Table.Cell className={"sub-table-cell text-bold"} width={2}>
              {_.get(bljRecord, "noticeType[0]._", "")} DATE:
            </Table.Cell>
            <Table.Cell className={"sub-table-cell"} width={2}>
              {getDate(_.get(bljRecord, "fileDate[0]"))}
            </Table.Cell>
            <Table.Cell className={"sub-table-cell text-bold"} width={2} />
            <Table.Cell className={"sub-table-cell"} width={4} />
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default BljBankruptcies;



// WEBPACK FOOTER //
// ./src/components/searchresults/BljBankruptcies.js